module.exports = __webpack_public_path__ + "static/media/sense4060.8733e8aa.jpg";